/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Start_Button_WaitingInputs */

const en_welcome_start_button_waiting = /** @type {(inputs: Welcome_Start_Button_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for the server`)
};

const fr_welcome_start_button_waiting = /** @type {(inputs: Welcome_Start_Button_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente du serveur`)
};

const ms_sg2_welcome_start_button_waiting = /** @type {(inputs: Welcome_Start_Button_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu pelayan`)
};

/**
* | output |
* | --- |
* | "Waiting for the server" |
*
* @param {Welcome_Start_Button_WaitingInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const welcome_start_button_waiting = /** @type {((inputs?: Welcome_Start_Button_WaitingInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Start_Button_WaitingInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_start_button_waiting(inputs)
	if (locale === "fr") return fr_welcome_start_button_waiting(inputs)
	return ms_sg2_welcome_start_button_waiting(inputs)
});